"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBar = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var AppBar_1 = __importDefault(require("@mui/material/AppBar"));
// import { useScrollPosition } from '@n8tb1t/use-scroll-position';
var clsx_1 = __importDefault(require("clsx"));
var usePrevious_1 = require("../hooks/usePrevious");
var base_1 = require("@mui/base");
var AppBarClasses_1 = __importStar(require("./AppBarClasses"));
var css_1 = require("@emotion/css");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        background: ['background'],
        expanded: ['expanded'],
        collapsed: ['collapsed'],
        expandedBackground: ['expandedBackground'],
    };
    return (0, base_1.unstable_composeClasses)(slots, AppBarClasses_1.getAppBarUtilityClass, classes);
};
var Root = (0, styles_1.styled)(AppBar_1.default, {
    shouldForwardProp: function (prop) { return !['backgroundImage', 'animationDuration'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var animationDuration = _a.animationDuration, backgroundImage = _a.backgroundImage, theme = _a.theme;
    return (_b = {
            overflow: 'hidden',
            transition: theme.transitions.create(['height'], {
                duration: animationDuration || theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
            })
        },
        _b["& .".concat(AppBarClasses_1.default.background)] = {
            position: 'absolute',
            zIndex: -1,
            width: '100%',
            backgroundSize: 'cover',
            height: '100%',
            opacity: 0.3,
            backgroundPosition: 'center bottom',
            backgroundImage: "url(".concat(backgroundImage, ")"),
            transition: theme.transitions.create(['all'], {
                duration: animationDuration || theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
        _b);
});
var AppBarRender = function (props, ref) {
    var _a;
    var theme = (0, styles_1.useTheme)();
    var isMobile = (0, useMediaQuery_1.default)(theme.breakpoints.down('sm'));
    var defaultAppBarHeight = isMobile ? '3.5rem' : '4rem';
    var _b = props.style, style = _b === void 0 ? {} : _b, _c = props.variant, variant = _c === void 0 ? 'snap' : _c, durationProp = props.animationDuration, _d = props.expandedHeight, expandedHeight = _d === void 0 ? 200 : _d, backgroundImage = props.backgroundImage, userClassName = props.className, _e = props.classes, classes = _e === void 0 ? {} : _e, _f = props.collapsedHeight, collapsedHeight = _f === void 0 ? defaultAppBarHeight : _f, 
    // onExpandedHeightReached,
    // onCollapsedHeightReached,
    _g = props.scrollThreshold, 
    // onExpandedHeightReached,
    // onCollapsedHeightReached,
    scrollThreshold = _g === void 0 ? 136 : _g, scrollContainerId = props.scrollContainerId, muiAppBarProps = __rest(props, ["style", "variant", "animationDuration", "expandedHeight", "backgroundImage", "className", "classes", "collapsedHeight", "scrollThreshold", "scrollContainerId"]);
    var scrollElement = scrollContainerId ? document.getElementById(scrollContainerId) : null;
    var scrollTop = scrollElement ? scrollElement.scrollTop : window.scrollY;
    var defaultClasses = useUtilityClasses(props);
    var animationDuration = durationProp || theme.transitions.duration.standard;
    var _h = (0, react_1.useState)(0), offset = _h[0], setOffset = _h[1];
    var previousOffset = (0, usePrevious_1.usePrevious)(offset);
    var previousCollapsedHeight = (0, usePrevious_1.usePrevious)(collapsedHeight);
    var previousExpandedHeight = (0, usePrevious_1.usePrevious)(expandedHeight);
    var _j = (0, react_1.useState)(false), scrolling = _j[0], setScrolling = _j[1];
    var _k = (0, react_1.useState)(false), animating = _k[0], setAnimating = _k[1];
    var _l = (0, react_1.useState)(false), endScrollHandled = _l[0], setEndScrollHandled = _l[1];
    var _m = (0, react_1.useState)(variant === 'collapsed'
        ? collapsedHeight
        : variant === 'expanded'
            ? expandedHeight
            : scrollTop > scrollThreshold
                ? collapsedHeight
                : expandedHeight), height = _m[0], setHeight = _m[1];
    var isExpanded = height === expandedHeight;
    // Smoothly collapse the toolbar to the collapsedHeight
    var collapseToolbar = (0, react_1.useCallback)(function () {
        setAnimating(true);
        setHeight(collapsedHeight);
        setTimeout(function () {
            setAnimating(false);
            setScrolling(false);
            if (scrollTop === 0) {
                (scrollElement || window).scrollTo(0, 1);
            }
        }, animationDuration + 50);
    }, [collapsedHeight, animationDuration, scrollTop, scrollElement]);
    // Smoothly expand the toolbar to the expandedHeight
    var expandToolbar = (0, react_1.useCallback)(function () {
        setAnimating(true);
        setHeight(expandedHeight);
        setTimeout(function () {
            setAnimating(false);
            setScrolling(false);
        }, animationDuration + 50);
    }, [expandedHeight, animationDuration]);
    // Adjust the height of the app bar when we cross the scroll thresholds
    (0, react_1.useEffect)(function () {
        if (animating || variant !== 'snap')
            return;
        if (previousOffset < scrollThreshold && offset >= scrollThreshold) {
            collapseToolbar();
        }
        // go from small to big if we scroll back to the top
        else if (previousOffset > 0 && offset === 0) {
            expandToolbar();
        }
    }, [offset, scrollThreshold]);
    // Properly update the height whenever the variant property changes
    (0, react_1.useEffect)(function () {
        if (variant === 'collapsed') {
            collapseToolbar();
        }
        else if (variant === 'expanded') {
            expandToolbar();
        }
        else {
            if (offset >= scrollThreshold) {
                collapseToolbar();
            }
            else {
                expandToolbar();
            }
        }
    }, [variant]);
    // Properly update the size when either height property changes
    (0, react_1.useEffect)(function () {
        if (previousExpandedHeight === undefined || previousCollapsedHeight === undefined)
            return;
        var wasExpanded = height === previousExpandedHeight;
        if (!wasExpanded) {
            collapseToolbar();
        }
        else {
            expandToolbar();
        }
    }, [collapsedHeight, expandedHeight]);
    // Returns the background image to apply on the app bar
    var getBackgroundImage = (0, react_1.useCallback)(function () {
        var _a;
        if (backgroundImage) {
            return (react_1.default.createElement("div", { className: (0, clsx_1.default)(defaultClasses.background, classes.background, (_a = {},
                    _a[defaultClasses.expandedBackground] = isExpanded,
                    _a[classes.expandedBackground] = isExpanded,
                    _a)) }));
        }
    }, [backgroundImage, defaultClasses, classes, isExpanded]);
    // This handler checks if the scrolling variable is true and adjusts the offset accordingly
    // We do not do this directly in the scroll event callback for performance reasons
    var handleScroll = (0, react_1.useCallback)(function () {
        if (scrolling && !animating) {
            setScrolling(false);
            setEndScrollHandled(false);
            if (scrollTop !== offset) {
                setOffset(scrollTop);
            }
        }
        // once the scroll ends, do one more update so we don't miss the latest value due to the debounce
        else if (!endScrollHandled) {
            setOffset(scrollTop);
            setEndScrollHandled(true);
        }
    }, [scrolling, animating, offset, endScrollHandled]);
    // This function listens for scroll events on the window and sets the scrolling variable to true
    (0, react_1.useEffect)(function () {
        (scrollElement || window).addEventListener('scroll', function () {
            setScrolling(true);
        });
        var scrollCheck = setInterval(handleScroll, 50);
        return function () {
            clearInterval(scrollCheck);
            (scrollElement || window).removeEventListener('scroll', function () { return setScrolling(true); });
        };
    }, [handleScroll]);
    return (react_1.default.createElement(Root, __assign({ ref: ref }, muiAppBarProps, { "data-testid": 'blui-appbar-root', className: (0, css_1.cx)(defaultClasses.root, classes.root, (_a = {},
            _a[classes.expanded] = isExpanded,
            _a[classes.collapsed] = !isExpanded,
            _a), userClassName), style: Object.assign({}, style, {
            height: height,
            overflow: 'hidden',
        }), position: 'sticky', backgroundImage: backgroundImage, animationDuration: durationProp }),
        getBackgroundImage(),
        props.children));
};
/**
 * [Appbar](https://brightlayer-ui-components.github.io/react/components/app-bar) component
 *
 * An extension of the default AppBar from Material UI that can be resized / collapsed as the page is scrolled.
 */
exports.AppBar = react_1.default.forwardRef(AppBarRender);
exports.AppBar.displayName = 'AppBar';
/* Additional code from the work on the continuous scrolling app bar that worked
but did not perform well with complex toolbars or applications. */
// Calculate the correct App Bar size
// const defaultAppBarHeight = isMobile ? theme.spacing(7) : theme.spacing(8);
// const collapsedHeight = collapsedHeightProp || defaultAppBarHeight;
// const calculatedHeight =
//     mode === 'collapsed'
//         ? collapsedHeight
//         : mode === 'expanded'
//             ? expandedHeight
//             : Math.round(Math.max(expandedHeight - offset, collapsedHeight));
// const calculatedMargin = mode === 'dynamic' ? expandedHeight - calculatedHeight : 0;
// const calculatedPosition =
//     mode === 'dynamic' ? (calculatedHeight <= collapsedHeight ? 'sticky' : 'relative') : props.position;
// TODO: This is inefficient...we listen for scroll events even if we are in a mode that doesn't react
// We may need to break this into two sub-components, one with scroll and one without since we can't
// conditionally execute React hooks.
// Update the height based on scroll position of WINDOW
// useScrollPosition(
//     ({ currPos }) => {
//         if (mode === 'dynamic') setOffset(currPos.y);
//     },
//     [offset, setOffset, mode],
//     undefined,
//     true
// );
// Handle callback functions when reaching the extremes of dynamic app bar
// useEffect(() => {
//     if (mode !== 'dynamic') return;
//     if (calculatedHeight >= expandedHeight && onExpandedHeightReached) onExpandedHeightReached();
//     if (calculatedHeight <= collapsedHeight && onCollapsedHeightReached) onCollapsedHeightReached();
// }, [mode, calculatedHeight, expandedHeight, collapsedHeight, onExpandedHeightReached, onCollapsedHeightReached]);
// This works for supporting a custom element scroller, but it's not very pretty
// const handleScroll = useCallback((e: any) => {
//     console.log('scrolling:', scrollRef?.current?.scrollTop);
//     setOffset(scrollRef?.current?.scrollTop);
// }, [setOffset, scrollRef, scrollRef?.current]);
//
// useEffect(() => {
//     if (scrollRef && scrollRef.current) {
//         // @ts-ignore
//         scrollRef?.current?.addEventListener('scroll', handleScroll);
//         // scrollRef?.current?.addEventListener('scroll', (e) => {
//         //     setOffset(scrollRef?.current?.scrollTop);
//         // });
//         return () => scrollRef?.current?.removeEventListener('scroll', handleScroll);
//     }
// }, [scrollRef, scrollRef?.current]);
